import React, {Component} from 'react'
import {Modal, Row} from 'antd'
import EmailForm from './EmailForm'

class EmailModal extends Component {
  render() {
    const {visible, send, sending, onCancel, formRef} = this.props
    return (
      <Modal
        visible={visible}
        title={'Send an Email'}
        width={'95%'}
        onCancel={onCancel}
        okText={'Send'}
        confirmLoading={sending}
        onOk={send}
        destroyOnClose={true}>
        <Row>
          <EmailForm ref={formRef} {...this.props} />
        </Row>
      </Modal>
    )
  }
}

EmailModal.propTypes = {}
EmailModal.defaultProps = {}

export default EmailModal
